import { watch, inject, ref, onBeforeUnmount } from '@vue/composition-api'
import { getQuestionDefault, isMissingValue } from '@shared/templates/defaults'
import _clonedeep from 'lodash/cloneDeep'

export default function useFieldDefaults ({
  field,
  fieldValue,
  update,
  isReadonly,
}) {
  const defaultsActive = inject('dynamic_form_defaults_active', ref(true))
  const resetTriggerCounter = inject('dynamic_form_reset_trigger_counter', ref(0))
  const defaultsConfigValue = getQuestionDefault(field.value, { deep: false })

  function setDefaults ({ force = false } = {}) {
    if (isReadonly.value || !defaultsActive.value || defaultsConfigValue === undefined) return

    const defaultValue = _clonedeep(defaultsConfigValue)

    const value = fieldValue.value

    // We don’t want to set defaults when the default value is falsy except `false`
    if (isMissingValue(defaultValue)) return

    // Only update fields that have empty values
    if (isMissingValue(value) || force) {
      update(defaultValue)
    }
  }
  const watchers = [
    watch(isReadonly, setDefaults, { immediate: true }),
    watch(resetTriggerCounter, () => setDefaults({ force: true })),
  ]
  onBeforeUnmount(() => watchers.forEach(unwatch => unwatch()))

  return {
    setDefaults,
  }
}
